import { render } from "./InfoReference.vue?vue&type=template&id=5781bb76"
import script from "./InfoReference.vue?vue&type=script&lang=js"
export * from "./InfoReference.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__